import React from 'react';
import { usePrecalculationContext } from './context';
import MainLayoutIgniter from '../../common/mainLayout';
import {
    NewStyledPrecalculationFormCardWrapper,
    StyledPrecalculationForm,
    StyledPrecalculationFormCard,
    StyledPrecalculationFormCardWrapper,
    StyledPrecalculationFormWrapper
} from './styles';
import { ArrowIcon } from '../../../../icons/ui/Arrow';
import Button from '../../../../libs/uiKit/button';
import { Heading2 } from '../../../../libs/uiKit/globalStyledComponents';
import { FieldsBuilder } from '../../../../libs/uiKit/fieldsBuilder';
import Tabs from '../../../../libs/uiKit/tabs';
import HouseInProgress from './HouseInProgress';
import HouseReady from './HouseReady';
import Result from './Result';
import { PROPERTY_TYPE } from '../../../../libs/utils/staticData';
import {Heading3, Heading4} from "../../../../libs/uiKit/globalStyles";
import {DownloadIcon} from "../../../../icons/ui/Download";

const PrecalculationUi: React.FC = () => {
	const {
        onFormSubmit,
        precalculationForm,
        isLoading,
        isDisabled,
        bankItems,
        bankAppend,
        resultItems,
        downloadAllHandler,
        isDataChanged,
    } =
		usePrecalculationContext();

	return (
		<MainLayoutIgniter>
			<StyledPrecalculationFormWrapper>
				{/*<Button onClick={goBackHandler} appearance='text' iconBefore={<ArrowIcon direction='left' />}>
					Назад
				</Button>*/}
				<NewStyledPrecalculationFormCardWrapper>
					<StyledPrecalculationFormCard>
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
						    <Heading2>{resultItems.length > 1 ? "Сравнение тарифов" : "Расчёт"}</Heading2>
                            {resultItems.length > 0 &&
                                <Button appearance='lightbluetext' onClick={downloadAllHandler} isLoading={isLoading} iconAfter={<DownloadIcon />} isDisabled={isDataChanged}
                                        style={{fontSize: '1.2rem'}} >
                                    Выгрузить результаты
                                </Button>
                            }
                        </div>
						<form onSubmit={onFormSubmit}>
							<StyledPrecalculationForm>
                                <Heading4>Кредитный договор</Heading4><br/><br/>
                                {bankItems.map((bank) => (
                                    <div key={bank.id}>
                                        <FieldsBuilder {...bank.form} />
                                    </div>
                                ))}
                                {bankItems.length < 3 &&
                                    <Button
                                        appearance="lightblue"
                                        style={{width: '24rem', marginBottom: '4rem'}}
                                        onClick={() => bankAppend({bank: undefined, rate: undefined})}
                                    >Добавить кредитора</Button>
                                }
								<FieldsBuilder {...precalculationForm} />
                                <br/>
                                <br/>
                                <Heading4>Что нужно застраховать?</Heading4><br/><br/>
								<HouseReady />
							</StyledPrecalculationForm>
                            { resultItems.length === 0 &&
                                <Button isDisabled={isDisabled} isLoading={isLoading} type='submit' appearance='filled' textFontSize="1.6rem">
                                    {bankItems.length > 1 ? "Сравнить" : "Рассчитать"}
                                </Button>
                            }
						</form>
					</StyledPrecalculationFormCard>
					<Result />
				</NewStyledPrecalculationFormCardWrapper>
			</StyledPrecalculationFormWrapper>
		</MainLayoutIgniter>
	);
};

export default React.memo(PrecalculationUi);
